import reporter from '../report';

export function safeStringify(value: unknown) {
  try {
    return JSON.stringify(value);
  } catch (e: any) {
    reporter.apiLog('[utils, strings]#safeStringify, e=', {
      level: 'error',
      message: e?.message,
    });
    return '';
  }
}
